import { Alert } from '@themenu/design-system'
import React, { lazy, Suspense, type ReactElement } from 'react'
import { useIntl } from 'react-intl'

import { Loader } from '../components/Loader'
import { ErrorBoundary } from '../components/Shared/ErrorBoundary'
import { Layout } from '../components/Shared/Layout'
import { useRequireAuth } from '../hooks/useRequireAuth'

const LazyChangeEmailPage = lazy(() =>
  import('../pages/ChangeEmail').then((module) => ({ default: module.ChangeEmailContainer })),
)

export const ChangeProfileEmailRoute = (): ReactElement => {
  const intl = useIntl()
  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  const errorFallback = (
    <Layout hideFooter>
      <div className="flex h-dvh items-center justify-center px-20">
        <Alert
          backgroundOpacity="solid"
          severity="error"
          title={intl.formatMessage({ id: 'profile.error.title' })}
          secondaryText={intl.formatMessage({ id: 'profile.error.boundary' })}
        />
      </div>
    </Layout>
  )

  return (
    <ErrorBoundary fallback={errorFallback}>
      <Suspense fallback={<Loader />}>
        <LazyChangeEmailPage />
      </Suspense>
    </ErrorBoundary>
  )
}
